// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationBundle_notification__1-3LT","dark_style":"NotificationBundle_dark_style__XlOBo","light_style":"NotificationBundle_light_style__zHpb7"};